import { useEffect, useState } from "react";
import PartnerOpportunitiesApi from "../../Api/PartnerOpportunitiesApi";
import { PartnerOpportunity, opportunityDisplayHeading } from "../../Models/PartnerOpportunity";

export default function MemberPartnerOpportunities({ memberId }: { memberId: number }) {
  const [items, setItems] = useState<PartnerOpportunity[]>([]);

  useEffect(() => {
    PartnerOpportunitiesApi.getByMember(memberId).then((res) => setItems(res.data));
  }, [memberId]);

  if (items.length < 1) {
    return <div className="p-2 text-gray-600">No open opportunities.</div>;
  }

  return (
    <div className="space-y-3">
      {items.map((item) => (
        <div key={item.id} className="border rounded-lg p-3">
          <div className="font-bold">{opportunityDisplayHeading(item)}</div>
          <div className="text-sm text-gray-700">{item.description}</div>
          <div className="text-xs text-gray-500 mt-1">Regions: {item.regions.join(", ") || "—"}</div>
        </div>
      ))}
    </div>
  );
}
